import { createSlice } from "@reduxjs/toolkit";

const compaignSlice = createSlice({
  name: "campaign",
  initialState: {
    formValue: {
      campaignName: "",
      recipients: "",
      smsText: "",
      startDate: null,
      startTime: null,
      sendBetweenStart: null,
      sendBetweenEnd: null,
      from_no: [],
      day: "",
      sendRate: "",
      endDate: null,
      endpointNumber: "",
      endpointDate: null,
    },
    plaintext: "",
    tagtext: "",
    permission: [],
  },
  reducers: {
    updateFormValue: (state, action) => {
      state.formValue = {
        ...state.formValue,
        ...action.payload,
      };
    },
    clearFormValue: (state) => {
      state.formValue = {
        campaignName: "",
        recipients: "",
        smsText: "",
        startDate: null,
        startTime: null,
        sendBetweenStart: null,
        sendBetweenEnd: null,
        from_no: [],
        day: "",
        sendRate: "",
        endDate: "",
        endpointNumber: "",
        endpointDate: null,
      };
    },
    updatePlainText: (state, action) => {
      state.plaintext = action.payload;
    },
    updateTagText: (state, action) => {
      state.tagtext = action.payload;
    },
    updatePermission: (state, action) => {
      state.permission = action.payload;
    },
  },
});

export const {
  updateFormValue,
  clearFormValue,
  updatePlainText,
  updateTagText,
  updatePermission,
} = compaignSlice.actions;
export default compaignSlice.reducer;
